module.exports = __webpack_public_path__ + "static/grafika13@2x-8545371c113b5f6048fcf28100594361.png";